import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { IdentifiedFieldIssue } from '../../IFITrackerContext/types'
import { IFIStatus, Permission } from 'shared'
import { useCreateIfiCommentMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useIFITrackerContext } from '../../IFITrackerContext'
import { HelpMessage } from 'utils/constants'
import { getPayItems } from '../../utils/getPayItems'
import reportFields from './reportFields'

export function useExpand(): ExpandOptions<IdentifiedFieldIssue> {
  const { refetch, edit } = useIFITrackerContext()
  const [create] = useCreateIfiCommentMutation({
    ...DefaultMutationHookOptions,
    onCompleted: () => refetch(),
  })
  const help = HelpMessage.IdentifiedFieldIssues.IFITracker
  return {
    render: (record) => {
      const { customFields, comments, reviewedDate, reportId, statusId } =
        record
      return {
        additionalInfo: [
          {
            type: 'date',
            label: 'Reviewed Date',
            format: 'datetime',
            help: help.IssueReviewDate,
            date: reviewedDate,
          },
          {
            type: 'payItems',
            object: 'Identified Field Issue',
            payItems: getPayItems(record),
          },
        ],
        custom: reportFields(record),
        comments: {
          comments,
          permission: Permission.CommentOnIdentifiedFieldIssue,
          onSave: (text) => {
            create({
              variables: { input: { text, identifiedFieldIssueId: reportId } },
            })
          },
        },
        customFields: {
          customFields,
          alreadyDisabled:
            statusId === IFIStatus.Closed.id
              ? {
                  why: 'invalid status',
                  statusName: IFIStatus.fromIdOrFail(statusId).name,
                }
              : false,
          booleanValueOptions: {
            onCheck: async (input) => {
              await edit({
                variables: {
                  input: { reportId, customFields: { booleanInputs: [input] } },
                },
              })
              refetch()
            },
          },
          listValueOptions: {
            onCheck: async (input) => {
              await edit({
                variables: {
                  input: {
                    reportId,
                    customFields: { listInputs: { checkboxes: [input] } },
                  },
                },
              })
              refetch()
            },
          },
        },
      }
    },
  }
}
